import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import chevronRightIcon from "../../../../assets/img/chevron_right_table.svg";
import chevronDownIcon from "../../../../assets/img/chevron_down_sm.svg";
import globeIcon from "../../../../assets/img/globe.svg";
import TruncatedText from "../../../../components/common/TruncatedText";
import { ROW_KIND } from "../constants";

const RatePlanCodeCell = ({ row, onToggleExpand }) => {
  const isBase = row.kind === ROW_KIND.BASE;

  const handleToggle = (event) => {
    event.stopPropagation();
    onToggleExpand(row);
  };

  let chevron;
  if (row.hasChildren) {
    const icon = row.isExpanded ? chevronDownIcon : chevronRightIcon;
    chevron = (
      <button
        type="button"
        className="rate-plans-derived-rate-page__chevron-btn"
        onClick={handleToggle}
        aria-label={row.isExpanded ? "Collapse row" : "Expand row"}
      >
        <img src={icon} alt="" width="12" height="12" />
      </button>
    );
  }

  return (
    <div className="rate-plans-derived-rate-page__code-cell">
      {chevron}
      {isBase && (
        <img
          src={globeIcon}
          alt=""
          className="rate-plans-derived-rate-page__globe-icon"
        />
      )}
      <TruncatedText
        text={row.code}
        className={classNames("rate-plans-derived-rate-page__code-text", {
          "rate-plans-derived-rate-page__code-text--bold": row.hasChildren,
        })}
      />
    </div>
  );
};

RatePlanCodeCell.propTypes = {
  row: PropTypes.shape({
    kind: PropTypes.string.isRequired,
    hasChildren: PropTypes.bool.isRequired,
    isExpanded: PropTypes.bool.isRequired,
    code: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  onToggleExpand: PropTypes.func.isRequired,
};

export default RatePlanCodeCell;
